export const menuData = [
  {
    name: "Teriyaki Beef Taco",
    description: "Tender beef glazed in sweet teriyaki sauce with crispy cabbage and sesame seeds.",
    price: "$4.50",
    category: "Signature Tacos",
    type: "non-veg",
    spicy: false,
    image: "https://plus.unsplash.com/premium_photo-1678051141689-1f7a7861b3b4?q=80&w=3087&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  },
  {
    name: "Spicy Tuna Crispy Taco",
    description: "Sashimi-grade tuna with spicy mayo, avocado, and tempura flakes in a hard shell.",
    price: "$5.99",
    category: "Signature Tacos",
    type: "non-veg",
    spicy: true,
    image: "https://images.unsplash.com/photo-1627564803215-ad55bad5c5ea?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8dGFjb3xlbnwwfHwwfHx8MA%3D%3D"
  },
  {
    name: "Miso Mushroom Taco",
    description: "Grilled shiitake and portobello mushrooms with miso glaze and pickled vegetables.",
    price: "$3.99",
    category: "Vegetarian Tacos",
    type: "veg",
    spicy: false,
    image: "https://images.unsplash.com/photo-1624300629298-e9de39c13be5?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fHRhY298ZW58MHx8MHx8fDA%3D"
  },
  {
    name: "Karaage Chicken Taco",
    description: "Japanese fried chicken with spicy mayo, cucumber, and nori flakes.",
    price: "$4.25",
    category: "Signature Tacos",
    type: "non-veg",
    spicy: true,
    image: "https://images.unsplash.com/photo-1618416019363-34805b84d3c1?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTl8fHRhY298ZW58MHx8MHx8fDA%3D"
  },
  {
    name: "Tempura Shrimp Taco",
    description: "Crispy tempura shrimp with wasabi crema and Asian slaw.",
    price: "$5.25",
    category: "Signature Tacos",
    type: "non-veg",
    spicy: true,
    image: "https://images.unsplash.com/photo-1574782091246-c65ed4510300?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fHRhY298ZW58MHx8MHx8fDA%3D"
  },
  {
    name: "Tofu Katsu Taco",
    description: "Panko-crusted tofu with tonkatsu sauce and shredded cabbage.",
    price: "$3.75",
    category: "Vegetarian Tacos",
    type: "veg",
    spicy: false,
    image: "https://plus.unsplash.com/premium_photo-1676466898955-c7c72261428a?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjF8fHRhY298ZW58MHx8MHx8fDA%3D"
  },
  {
    name: "Salmon Teriyaki Taco",
    description: "Grilled salmon with teriyaki glaze, cucumber, and sriracha aioli.",
    price: "$5.75",
    category: "Premium Tacos",
    type: "non-veg",
    spicy: true,
    image: "https://images.unsplash.com/photo-1593759608136-45eb2ad9507d?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzV8fHRhY298ZW58MHx8MHx8fDA%3D"
  },
  {
    name: "Gyoza Pork Taco",
    description: "Seasoned ground pork with gyoza flavors, cabbage slaw, and ginger sauce.",
    price: "$4.75",
    category: "Signature Tacos",
    type: "non-veg",
    spicy: false,
    image: "https://plus.unsplash.com/premium_photo-1664648234252-3f7e2a713795?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzN8fHRhY298ZW58MHx8MHx8fDA%3D"
  },
  {
    name: "Edamame Hummus Taco",
    description: "House-made edamame hummus with roasted vegetables and sesame dressing.",
    price: "$3.50",
    category: "Vegetarian Tacos",
    type: "veg",
    spicy: false,
    image: "https://images.unsplash.com/photo-1633271306841-0e5cce5d794f?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzZ8fHRhY298ZW58MHx8MHx8fDA%3D"
  },
  {
    name: "Yakitori Chicken Taco",
    description: "Grilled chicken thigh with yakitori sauce, green onions, and sesame seeds.",
    price: "$4.50",
    category: "Signature Tacos",
    type: "non-veg",
    spicy: false,
    image: "https://plus.unsplash.com/premium_photo-1665972824374-9bac6a0862a0?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NTd8fHlha2l0b3JpJTIwdGFjb3xlbnwwfHwwfHx8MA%3D%3D"
  },
  {
    name: "Miso Glazed Eggplant Taco",
    description: "Grilled Japanese eggplant with sweet miso glaze and micro greens.",
    price: "$3.99",
    category: "Vegetarian Tacos",
    type: "veg",
    spicy: false,
    image: "https://images.unsplash.com/photo-1660180750968-4fbc84789a96?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NjR8fHRhY298ZW58MHx8MHx8fDA%3D"
  },
  {
    name: "Wagyu Beef Taco",
    description: "Premium wagyu beef with wasabi cream, pickled radish, and microgreens.",
    price: "$7.99",
    category: "Premium Tacos",
    type: "non-veg",
    spicy: true,
    image: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=400&fit=crop&q=80"
  },
  // Sides and Appetizers
  {
    name: "Gyoza Dumplings",
    description: "Pan-fried pork dumplings with dipping sauce.",
    price: "$6.99",
    category: "Appetizers",
    type: "non-veg",
    spicy: false,
    image: "https://images.unsplash.com/photo-1496116218417-1a781b1c416c?w=400&h=400&fit=crop&q=80"
  },
  {
    name: "Seaweed Salad",
    description: "Fresh wakame seaweed with sesame dressing.",
    price: "$4.99",
    category: "Sides",
    type: "veg",
    spicy: false,
    image: "https://images.unsplash.com/photo-1565299507177-b0ac66763828?w=400&h=400&fit=crop&q=80"
  },
  {
    name: "Japanese Rice Bowl",
    description: "Seasoned sushi rice with furikake and sesame seeds.",
    price: "$3.99",
    category: "Sides",
    type: "veg",
    spicy: false,
    image: "https://images.unsplash.com/photo-1565299507177-b0ac66763828?w=400&h=400&fit=crop&q=80"
  },
  {
    name: "Mochi Ice Cream",
    description: "Traditional Japanese dessert with green tea, vanilla, or red bean flavors.",
    price: "$5.99",
    category: "Desserts",
    type: "veg",
    spicy: false,
    image: "https://images.unsplash.com/photo-1563805042-7684c019e1cb?w=400&h=400&fit=crop&q=80"
  }
];